import { Divider } from 'antd';
import AtsDivider from './styles/divider.style';

export default AtsDivider(Divider);
